export {
  dateOnly,
  datetimeLocalToIso,
  formatCompactDateTime as formatConversationTime,
  formatCompactDateTime as formatTimestamp,
  formatDateTime,
  parseTimestamp,
  toIsoZ,
} from "../../shared/time.js";

export function conversationTitleFromMessage(value) {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  if (!text) {
    return "新对话";
  }
  return Array.from(text).slice(0, 10).join("");
}
